<div  class="array-box">
    <div class="tool-field" *ngIf="title!=null">
        <b class="title-field">{{title}}</b>
    </div>
    <form [formGroup]="formItem" class="form-array">
        <div class="display-filegroup-item-components">
            <div *ngFor="let item of formConfiguration" class="display-filegroup-item-components-lines" [hidden]="item.hide" >
                <ng-container>
                    <div class="tem-field full" *ngIf="item.type=='string'">
                        <label class="tem-field-label">{{item.title}}<span class="tem-field-required" *ngIf="item.required"> *</span></label>
                        <input nz-input type="text"
                                (focus)="item.onClick!=null? item.onClick($event):null"
                                [name]="item.name"
                                [formControlName]="item.name"
                                [placeholder]="item.placeHolder || ''"
                                nz-tooltip [nzTooltipTitle]="item.tooltip">
                    </div>
                    <div class="tem-field full" *ngIf="item.type=='password'">
                        <label class="tem-field-label">{{item.title}}<span class="tem-field-required" *ngIf="item.required"> *</span></label>
                        <nz-input-group [nzSuffix]="suffixPass">
                            <input nz-input [type]="item.hidePassWord ? 'password' : 'text'"
                                    (focus)="item.onClick!=null? item.onClick($event):null"
                                    [name]="item.name"
                                    [formControlName]="item.name"
                                    [placeholder]="item.placeHolder || ''"
                                    nz-tooltip [nzTooltipTitle]="item.tooltip">
                        </nz-input-group>
                        <ng-template #suffixPass>
                            <nz-icon class="suffix-icon" [nzType]="item.hidePassWord ? 'eye-invisible' : 'eye'" (click)="item.hidePassWord = !item.hidePassWord"></nz-icon>
                        </ng-template>
                    </div>
                    <div class="tem-field full" *ngIf="item.type=='number'">
                        <label class="tem-field-label">{{item.title}}<span class="tem-field-required" *ngIf="item.required"> *</span></label>
                        <input nz-input type="number"
                                (focus)="item.onClick!=null? item.onClick($event):null"
                                [name]="item.name"
                                [formControlName]="item.name"
                                [placeholder]="item.placeHolder || ''"
                                nz-tooltip [nzTooltipTitle]="item.tooltip">
                    </div>
                    <div class="tem-field full" *ngIf="item.type=='formula'">
                        <label class="tem-field-label">{{item.title}}<span class="tem-field-required" *ngIf="item.required"> *</span></label>
                        <nz-input-group [nzSuffix]="suffixFormula">
                            <input nz-input type="text" #inp
                                    (focus)="item.onClick!=null? item.onClick($event):null"
                                    [name]="item.name"
                                    [formControlName]="item.name"
                                    [placeholder]="item.placeHolder || ''"
                                    nz-tooltip [nzTooltipTitle]="item.tooltip">
                        </nz-input-group>
                        <ng-template #suffixFormula>
                            <nz-icon class="suffix-icon" nzType="thunderbolt" (click)="openFormula(inp.value, item.name, formItem)"></nz-icon>
                        </ng-template>
                    </div>
                    <div class="tem-field full" *ngIf="item.type=='select'">
                        <label class="tem-field-label">{{item.title}}<span class="tem-field-required" *ngIf="item.required"> *</span></label>
                        <nz-select [name]="item.name"
                                    [formControlName]="item.name"
                                    [nzPlaceHolder]="item.placeHolder || item.title"
                                    nzShowSearch
                                    nz-tooltip [nzTooltipTitle]="item.tooltip">
                            <nz-option *ngFor="let data of item.optionsFiltered || item.options" [nzValue]="data.key"
                                [nzLabel]="item.optionsHideKey == true ? data.value : data.key + ' - ' + data.value"></nz-option>
                        </nz-select>
                    </div>

                    <div class="toggle-line" *ngIf="item.type=='toggle' && !item.hide" nz-tooltip [nzTooltipTitle]="item.tooltip">
                        <nz-switch [formControlName]="item.name" nzSize="small"></nz-switch>
                        <span class="toggle-label">{{item.title}}</span>
                    </div>

                    <div class="tem-field full" *ngIf="item.type=='chips'">
                        <label class="tem-field-label">{{item.title}}</label>
                        <nz-select nzMode="tags"
                            [formControl]="getChipFormControl(selectedIndex,item.name)"
                            nzPlaceHolder="Novo Valor (chave=valor)..."
                            [nzTokenSeparators]="[',']">
                        </nz-select>
                    </div>
                    <search-input  *ngIf="item.type=='search'" [entityname]="item.entityName"  [entitydesc]="item.entityDesc" [form]="formItem" [controlname]="item.controlName" [placeholder]="item.placeHolder" [columnname]="item.columnName" class="no-padding-form-field" [loaddesc]="true" [columndesc]="item.description" [fieldname]="item.fieldName" [condition]="item.condition" >
                    </search-input>
                </ng-container>
            </div>
        </div>
        <div class="action-buttons">
            <div class="itens-save" *ngIf="showSaveButton">
                <button nz-button nzType="primary" nzShape="circle" nz-tooltip="Salvar" (click)="save()" type="button">
                    <nz-icon nzType="check"></nz-icon>
                </button>
            </div>
            <div class="itens-save" *ngIf="showCancelButton">
                <button nz-button nzType="primary" nzDanger nzShape="circle" nz-tooltip="Cancelar" (click)="cancel()" type="button">
                    <nz-icon nzType="close"></nz-icon>
                </button>
            </div>
        </div>
    </form>
</div>
